import { useEffect, useState, FunctionComponent } from 'react';
import Plotly from 'react-plotly.js';
import { FetchDataForReporting, QueryObject } from './ReportDataFetch';
import { Filter, FilterComponent } from './ReportFilter';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export interface GraphControllerProps {
  data: QueryObject;
  graph: Partial<Plotly.PlotData>;
  layout: Partial<Plotly.Layout>;
  filters?: { [s: string]: Filter };
}

export const GraphController: FunctionComponent<GraphControllerProps> = graphConfig => {
  const { data, graph, layout } = graphConfig;
  const [values, setValues] = useState<any[]>([]);
  const [labels, setLabels] = useState<any[]>([]);
  const [params, setParams] = useState(data.params);
  const [showSidebar, setSidebarVisibility] = useState(false);

  useEffect(() => {
    data.params = params;
    FetchDataForReporting(data).then(response => {
      setValues(response.values);
      setLabels(response.labels);
    });
  }, [data, params]);

  const onFilterChange = (key: string, s: any) => {
    setParams(prev => {
      const newParam = { ...prev };
      if (!s || s === 'null') delete newParam[key];
      else newParam[key] = s;
      return newParam;
    });
  };

  const filters = graphConfig.filters;

  const toggleSidebar = () => {
    setSidebarVisibility(!showSidebar);
  };

  const downloadAsCSV = () => {
    const text =
      `${data.labels},${data.values}\n` +
      labels.reduce((p, c, i) => p + c + ',' + values[i] + '\n', '');
    console.log(text);
    const blob = new Blob([text], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = data.api.split('/').pop() || 'exported';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="graphContainer">
      {showSidebar ? (
        <ArrowLeftOutlined
          className="sidebarToggle"
          onClick={toggleSidebar}
        ></ArrowLeftOutlined>
      ) : (
        <ArrowRightOutlined
          className="sidebarToggle"
          onClick={toggleSidebar}
        ></ArrowRightOutlined>
      )}
      <div className={`sidebar ${showSidebar ? '' : 'hidden'}`}>
        <div className="graphFilters">
          {filters
            ? Object.keys(filters).map((key, i) => (
                <FilterComponent
                  key={i}
                  {...{
                    ...filters[key],
                    onChange: s => onFilterChange(key, s)
                  }}
                ></FilterComponent>
              ))
            : null}
          <Button onClick={downloadAsCSV}>Download Data</Button>
        </div>
      </div>
      <Plotly
        data={[
          graph.type === 'bar'
            ? {
                ...graph,
                x: values,
                y: labels
              }
            : {
                ...graph,
                values: values,
                labels: labels ? labels : graph.labels
              }
        ]}
        layout={{ ...layout }}
        config={{
          scrollZoom: true,
          displaylogo: false
        }}
      />
    </div>
  );
};
